class ESRPointsGuide extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.translations = {
      title: this.getAttribute('data-title'),
      subtitle: this.getAttribute('data-subtitle'),
      points_unit: this.getAttribute('data-points_unit'),
    };
    this.render();
  }

  async connectedCallback() {
    await this.fetchData();
    insertMatchedStyleToShadowDOM(['.g-button', '.g-button--primary', '.guide-section'], this.shadowRoot)();
  }

  disconnectedCallback() {
    // 将数据都清 0
    this.shadowRoot.querySelector('.points-guide__content').innerHTML = '';
  }

  async fetchData() {
    try {
      // 替换为实际的API endpoint
      const response = await fetchJSON('/apps/esrvip/vip/vip-level-point-rules');

      if (response.code !== 200) {
        this.showError(response.message);
        return;
      }

      const data = response.data;
      // const data = [
      //   { reward_mode: 'fullfill_info', reward_value: 100 },
      //   { reward_mode: 'complete_email_set', reward_value: 100 },
      //   { reward_mode: 'birthdate', reward_value: 100 },
      //   // { reward_mode: 'order_paid', reward_value: 100 },
      //   // { reward_mode: 'distribution', reward_value: 100 },
      // ];
      // const data = [
      //   {
      //     title: 'Fill in profile information',
      //     description: 'Complete your account information',
      //     points: 100,
      //     link: '#my-profile',
      //     buttonText: 'Complete Now',
      //   },
      //   {
      //     title: 'Email Preferences',
      //     description: 'Complete your email preferences',
      //     points: 100,
      //     link: '#email-preferences',
      //     buttonText: 'Complete Now',
      //   },
      //   {
      //     title: 'Shop',
      //     description:
      //       'Earn 1 Point for every US dollar spent on all orders at esr store or on Amazon. Get double points for orders not returned within 30 days. Request a refund or a free replacement through our help center.',
      //     points: 100,
      //     link: '/collections/all',
      //     buttonText: 'Complete Now',
      //   },
      //   {
      //     title: 'Birthday',
      //     description: 'Earn 100 Points on your birthday',
      //     points: 100,
      //     link: '#birthday',
      //     buttonText: 'Complete Now',
      //   },
      //   {
      //     title: 'Recommend',
      //     description: 'Recommend esr to your friends and earn 100 Points for each friend who makes a purchase',
      //     points: 100,
      //     link: '#recommend',
      //     buttonText: 'Complete Now',
      //   },
      // ];

      this.renderGuides(data);
    } catch (error) {
      this.showError(error.message || 'Failed to fetch points guide');
    }
  }

  render() {
    const iconProfile = `https://cdn.shopify.com/s/files/1/0714/7025/2286/files/icon-profile.webp?v=1732002943`;
    const iconEmail = `https://cdn.shopify.com/s/files/1/0714/7025/2286/files/icon-email.webp?v=1732002943`;
    const iconShop = `https://cdn.shopify.com/s/files/1/0714/7025/2286/files/icon-shop.webp?v=1732002943`;
    const iconBirthday = `https://cdn.shopify.com/s/files/1/0714/7025/2286/files/icon-birthday.webp?v=1732002943`;
    const iconRecommend = `https://cdn.shopify.com/s/files/1/0714/7025/2286/files/icon-recommend.webp?v=1732002943`;
    const style = `
      <style>
        .points-guide {
          margin-bottom: 64px;
        }

        .points-guide__header {
          margin-bottom: 32px;
        }

        .points-guide__title {
          font-size: 24px;
          font-weight: 600;
          color: #3d3d3d;
          margin: 0 0 8px;
        }

        .points-guide__subtitle {
          font-size: 14px;
          color: #999;
          margin: 0;
        }

        .points-guide__row {
          display: flex;
          gap: 24px;
          margin-bottom: 24px;
        }

        .points-guide__row:last-child {
          margin-bottom: 0;
        }

        .points-guide__row--first .guide-card,
        .points-guide__row--second .guide-card {
          flex: 1;
        }

        .guide-card {
          background: #F7F8FD;
          border-radius: 12px;
          padding: 24px;
          display: flex;
          flex-direction: column;
          position: relative;
          overflow: hidden;
        }

        .guide-card__title {
          font-size: 16px;
          font-weight: 600;
          color: #000;
          margin: 0 0 8px;
        }

        .guide-card__description {
          font-size: 14px;
          color: #666;
          margin: 0 0 24px;
          flex-grow: 1;
        }

        .guide-card__points,
        .guide-card__points--mobile {
          color: #1790FF;
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 16px;
        }

        .guide-card__button {
          align-self: flex-start;
          text-decoration: none;
        }

        .guide-card__icon {
          position: absolute;
          bottom: -20px;
          right: -20px;
          width: 120px;
          height: 120px;
          background: linear-gradient(135deg, #999 0%, #eee 100%);
        }

        .guide-card__icon--profile {
          mask: url('${iconProfile}') center/contain no-repeat;
          -webkit-mask: url('${iconProfile}') center/contain no-repeat;
        }

        .guide-card__icon--email {
          mask: url('${iconEmail}') center/contain no-repeat;
          -webkit-mask: url('${iconEmail}') center/contain no-repeat;
        }

        .guide-card__icon--shop {
          mask: url('${iconShop}') center/contain no-repeat;
          -webkit-mask: url('${iconShop}') center/contain no-repeat;
        }

        .guide-card__icon--birthday {
          mask: url('${iconBirthday}') center/contain no-repeat;
          -webkit-mask: url('${iconBirthday}') center/contain no-repeat;
        }

        .guide-card__icon--recommend {
          mask: url('${iconRecommend}') center/contain no-repeat;
          -webkit-mask: url('${iconRecommend}') center/contain no-repeat;
        }

        @media screen and (min-width: 768px) {
          .guide-card__points--mobile {
            display: none;
          }
        }

        @media screen and (max-width: 768px) {
          .points-guide__title {
            font-size: 16px;
          }

          .points-guide__subtitle {
            font-size: 12px;
          }

          .points-guide__header {
            margin-bottom: 16px;
          }

          .points-guide__row {
            flex-direction: column;
            gap: 16px;
          }

          .guide-card {
            padding: 12px;
            border-radius: 6px;
          }

          .guide-card__title {
            font-size: 15px;
          }

          .guide-card__description {
            color: #787878;
            font-size: 12px;
            margin: 0 0 19px;
          }

          .guide-card__icon {
            bottom: 12px;
            right: 12px;
            width: 64px;
            height: 64px;
            background: linear-gradient(135deg, #000 0%, #000 100%);
          }

          .guide-card__points {
            display: none;
          }

          .guide-card__points--mobile {
            display: block;
            margin-bottom: 0;
          }

          .guide-card__button-wrapper {
            display: flex;
            align-items: center;
            gap: 18px;
          }
        }
      </style>
    `;

    this.shadowRoot.innerHTML = `
      ${style}
      <div class="points-guide guide-section" part="points-guide">
        <div class="points-guide__header">
          <h2 class="points-guide__title">${this.translations.title}</h2>
          <p class="points-guide__subtitle">${this.translations.subtitle}</p>
        </div>
        <div class="points-guide__content"></div>
      </div>
    `;
  }

  renderGuides(guides) {
    // 定义顺序映射
    const orderMap = {
      fullfill_info: 0,
      complete_email_set: 1,
      order_paid: 2,
      birthdate: 3,
      distribution_rules: 4,
    };

    // 对数据进行排序
    // const sortedGuides = guides.sort((a, b) => {
    //   return orderMap[a.reward_mode] - orderMap[b.reward_mode];
    // });

    // 将指南分成两行
    const firstRow = guides.slice(0, 3);
    const secondRow = guides.slice(3);

    const root = window.GkifySettings.routes.root == '/' ? '' : window.GkifySettings.routes.root;

    // 获取对应的图标和链接
    const getGuideInfo = (mode) => {
      switch (mode) {
        case 'fullfill_info':
          return {
            icon: 'profile',
            link: `${root}/pages/member#my-profile`,
            title: 'Fill in profile information',
            description: t('customer.vip_points.fullfill_info_description'),
          };
        case 'complete_email_set':
          return {
            icon: 'email',
            link: `${root}/pages/member#email-preferences`,
            title: 'Email Preferences',
            description: t('customer.vip_points.complete_email_set_description'),
          };
        case 'order_paid':
          return {
            icon: 'shop',
            link: '/collections/all',
            title: 'Shop',
            description: t('customer.vip_points.order_paid_description'),
          };
        case 'birthdate':
          return {
            icon: 'birthday',
            link: `${root}/pages/member#my-profile`,
            title: 'Birthday',
            description: t('customer.vip_points.birthdate_description'),
          };
        case 'distribution_rules':
          return {
            icon: 'recommend',
            link: `${root}/pages/referral`,
            title: 'Refer a friend',
            description: t('customer.vip_points.distribution_rules_description'),
          };
        default:
          return {
            icon: 'profile',
            link: '#',
            title: '',
            description: '',
          };
      }
    };

    const container = this.shadowRoot.querySelector('.points-guide__content');
    container.innerHTML = `
      <div class="points-guide__row points-guide__row--first">
        ${firstRow
        .map((guide, index) => {
          const info = getGuideInfo(guide.reward_mode);
          return this.renderCard(
            {
              ...guide,
              ...info,
            },
            index
          );
        })
        .join('')}
      </div>
      ${secondRow.length > 0
        ? `
        <div class="points-guide__row points-guide__row--second">
          ${secondRow
          .map((guide, index) => {
            const info = getGuideInfo(guide.reward_mode);
            return this.renderCard(
              {
                ...guide,
                ...info,
              },
              index + 3
            );
          })
          .join('')}
        </div>
      `
        : ''
      }
    `;
  }

  renderCard(guide, index) {
    return `
      <div class="guide-card">
        <h3 class="guide-card__title">${guide.title}</h3>
        <p class="guide-card__description">${guide.description}</p>
        ${guide.reward_value ? `<div class="guide-card__points">+${guide.reward_value} ${this.translations.points_unit}</div>` : ''}
        <a href="${guide.link}" class="g-button g-button--primary guide-card__button ${guide.customer_status ? '' : 'g-button--disabled'
      }">
          ${guide.buttonText || 'Complete Now'}
        </a>
        <div class="guide-card__icon guide-card__icon--${guide.icon}"></div>
      </div>
    `;
  }
}

customElements.define('esr-points-guide', ESRPointsGuide);
